import Title from "@components/common/Title";
import { AuthorResponseModel } from "@models/users";
import React from "react";
import { WebinarPointsModel } from "@models/webinar";
import useIcons from "@hooks/use-source-icons";
import { twMerge } from "tailwind-merge";
import AuthorWrapper from "./AuthorWraper";
import VizWrapper from "@components/common/Base/VizWrapper";
export interface WebinarPointsPropsModel {
  authors?: AuthorResponseModel[];
  webinarPointsData: WebinarPointsModel;
  wrapperClassName?: string;
  speakerWriterHeader?: string;
}

const WebinarPoints: React.FunctionComponent<WebinarPointsPropsModel> = ({
  webinarPointsData,
  authors,
  wrapperClassName = "",
  speakerWriterHeader = "Speaker",
}) => {
  // const [[], setPage] = useState([0, 0]);
  const { getFromReactIcons } = useIcons();
  const { title, points } = webinarPointsData ?? {};
  const wrapperDynamicClassName =
    authors && authors?.length >= 1 ? "basis-1/2" : "w-full";

  if (authors?.length === 0) return <></>;

  return (
    <VizWrapper
      className={twMerge(
        "md:flex justify-between gap-8 px-8 lg:px-0",
        wrapperClassName
      )}
    >
      <div className={wrapperDynamicClassName}>
        <Title
          variant="h2"
          titleText={title}
          className="text-left md:max-w-[80%]"
        />
        {points?.map((onePoint) => {
          const { title, subTitle, icon, id } = onePoint;
          const Icon = icon ? getFromReactIcons(icon) : () => <></>;
          return (
            <div key={id} className="flex mt-[37px] lg:max-w-[70%]">
              <div className="flex items-start mb-2">
                <span
                  className={twMerge(
                    "mr-[13px]",
                    title?.length ? "mt-2" : "mt-0.5"
                  )}
                >
                  {Icon && <Icon className="fill-primary-blue-50" size={20} />}
                </span>
              </div>
              <div>
                {title && <Title variant="h3" titleText={title} />}
                {subTitle && <Title variant="paragraph" titleText={subTitle} />}
              </div>
            </div>
          );
        })}
      </div>
      <AuthorWrapper
        authors={authors}
        speakerWriterHeader={speakerWriterHeader}
      />
    </VizWrapper>
  );
};

export default WebinarPoints;
